<div id="success-password-reset" class="flex flex-col" fusePerfectScrollbar>
  <div
    id="success-password-reset-form-wrapper"
    class="flex items-center justify-center"
    *fuseIfOnDom
    [@animate]="{ value: '*', params: { duration: '300ms', y: '100px' } }">
    <div id="success-password-reset-form">
      <div class="logo">
        <img src="./assets/images/logos/fuse.svg" />
      </div>

      <div i18n class="title">ПАРОЛЬ ИЗМЕНЕН</div>

      <div class="login" *ngIf="userId">
        <a i18n class="link" [routerLink]="['/client/auth/login']" [queryParams]="{ user: userId }"
          >Вернуться на страницу авторизации</a
        >
      </div>
    </div>
  </div>
</div>
